import React from "react";

import "../Star.css";

const Star1 = () => {
  return (
    <span>
      <span className="fa fa-star-half-alt"></span>
      <span className="fa fa-star"></span>
      <span className="fa fa-star"></span>
      <span className="fa fa-star"></span>
      <span className="fa fa-star"></span>
    </span>
  );
};

export default Star1;
